import { HttpStatusCode } from '../../common/enums';

export interface IGenericApiResponse<T = any> {
  isSuccess?: boolean;
  className?: string;
  code?: HttpStatusCode;
  data?: T;
  error?: any;
  message?: string;
  name?: string;
}
export class GenericApiResponse<T = any> {
  /**
   *
   */
  isSuccess?: boolean;
  className?: string;
  code?: HttpStatusCode;
  data?: T;
  error?: any;
  message?: string;
  name?: string;

  constructor(success: boolean, opt?: IGenericApiResponse<T>) {
    this.isSuccess = success;
    Object.keys(opt).forEach(key => this[key] = opt[key]);
  }
}


// WEBPACK FOOTER //
// ./src/models/generic/generic-api-response.ts